import React from 'react';
import { Box, Button } from '@mui/material';
import { QuizStyles } from '../../styles/QuizStyles';

interface QuizNavigationProps {
  currentIndex: number;
  totalQuestions: number;
  onPrevious: () => void;
  onNext: () => void;
  isCurrentQuestionAnswered: boolean;
  isAllQuestionsCompleted: boolean;
}

const QuizNavigation: React.FC<QuizNavigationProps> = ({
  currentIndex,
  totalQuestions,
  onPrevious,
  onNext,
  isCurrentQuestionAnswered,
  isAllQuestionsCompleted,
}) => {
  return (
    <Box sx={QuizStyles.buttonContainer}>
      <Button
        sx={[QuizStyles.button, QuizStyles.backButton]}
        disabled={currentIndex === 0}
        variant="outlined"
        onClick={onPrevious}
      >
        Back
      </Button>
      <Button
        sx={[QuizStyles.button, QuizStyles.nextButton]}
        variant="contained"
        disabled={
          (currentIndex === totalQuestions - 1 && !isAllQuestionsCompleted) || !isCurrentQuestionAnswered
        }
        onClick={onNext}
      >
        Next
      </Button>
    </Box>
  );
};

export default QuizNavigation;
